import { useState } from 'react';
import Modal from './Modal';

const card = 'bg-card text-card-foreground border border-border rounded-lg shadow-sm';

export function CitationAssessment({ assessment }) {
  const [open, setOpen] = useState(false);
  if (!assessment?.paragraphs?.length) return null;

  const cited = (assessment.missed || []).filter(item => item.hosts.length > 0);

  return (
    <>
      <section className={`${card} mb-6 flex items-center justify-between gap-4 px-6 py-4`} aria-label="Assessment">
        <div className="min-w-0">
          <h2 className="text-sm font-semibold">Assessment</h2>
          <p className="truncate text-sm text-muted-foreground">{assessment.paragraphs[0]}</p>
        </div>
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="shrink-0 text-sm font-medium text-foreground hover:underline"
        >
          Read
        </button>
      </section>

      <Modal title="Assessment" isOpen={open} onClose={() => setOpen(false)} size="lg">
        <div className="space-y-4 px-6 py-5">
          {assessment.paragraphs.map(paragraph => (
            <p key={paragraph} className="text-base leading-relaxed text-foreground">
              {paragraph}
            </p>
          ))}
          {cited.length > 0 && (
            <div className="pt-2">
              <h3 className="mb-3 text-sm font-semibold text-foreground">Cited instead</h3>
              <ul className="space-y-3">
                {cited.map(item => (
                  <li key={item.prompt}>
                    <div className="font-medium text-foreground">{item.prompt}</div>
                    <p className="text-sm leading-relaxed text-muted-foreground">
                      {item.hosts.map(host => `${host.host} in ${host.answers} of ${item.ok} answers`).join(' · ')}
                    </p>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
}
